const hasLowerCase = (val: string): boolean => val.toUpperCase() !== val;

export default hasLowerCase;
